/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: script.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateScriptRequest,
  CreateScriptResponse,
  DeleteScriptRequest,
  DeleteScriptResponse,
  GetActiveScriptRequest,
  GetActiveScriptResponse,
  GetOutputSchemaRequest,
  GetOutputSchemaResponse,
  GetScriptRequest,
  GetScriptResponse,
  ListScriptsRequest,
  ListScriptsResponse,
  UpdateScriptRequest,
  UpdateScriptResponse,
} from '../types/script';

export const createScriptService = (transport: Transport) => ({
  async createScript(
    request: CreateScriptRequest,
    options: RequestOptions = {},
  ): Promise<CreateScriptResponse> {
    const url = getApiPath(API_METHODS.ScriptService.CreateScript);
    return transport.post<CreateScriptResponse>(url, request, options);
  },

  async getScript(
    request: GetScriptRequest,
    options: RequestOptions = {},
  ): Promise<GetScriptResponse> {
    const { script_id } = request;
    const url = getApiPath(API_METHODS.ScriptService.GetScript, { script_id });
    return transport.get<GetScriptResponse>(url, options);
  },

  async listScripts(
    request: ListScriptsRequest,
    options: RequestOptions = {},
  ): Promise<ListScriptsResponse> {
    const url = getApiPath(API_METHODS.ScriptService.ListScripts);
    return transport.get<ListScriptsResponse>(url, { params: request, ...options });
  },

  async updateScript(
    request: UpdateScriptRequest,
    options: RequestOptions = {},
  ): Promise<UpdateScriptResponse> {
    const { script_id, ...body } = request;
    const url = getApiPath(API_METHODS.ScriptService.UpdateScript, { script_id });
    return transport.post<UpdateScriptResponse>(url, body, options);
  },

  async deleteScript(
    request: DeleteScriptRequest,
    options: RequestOptions = {},
  ): Promise<DeleteScriptResponse> {
    const { script_id } = request;
    const url = getApiPath(API_METHODS.ScriptService.DeleteScript, { script_id });
    return transport.delete<DeleteScriptResponse>(url, options);
  },

  async getOutputSchema(
    request: GetOutputSchemaRequest,
    options: RequestOptions = {},
  ): Promise<GetOutputSchemaResponse> {
    const url = getApiPath(API_METHODS.ScriptService.GetOutputSchema);
    return transport.get<GetOutputSchemaResponse>(url, { params: request, ...options });
  },

  async getActiveScript(
    request: GetActiveScriptRequest,
    options: RequestOptions = {},
  ): Promise<GetActiveScriptResponse> {
    const { organization_id, program_id, workflow_id } = request;
    const url = getApiPath(API_METHODS.ScriptService.GetActiveScript, {
      organization_id,
      program_id,
      workflow_id,
    });
    return transport.get<GetActiveScriptResponse>(url, options);
  },
});

export type ScriptService = ReturnType<typeof createScriptService>;
